import { Vue, Component } from 'vue-property-decorator';
import '@/registerVuePlugins';

import { default as TasksPage } from './Components/TasksPage.vue';

@Component({
  name: 'tasks-component',
  components: { TasksPage }
})
class TasksComponent extends Vue {
  public verificationToken: string = '';

  public async mounted() {
    this.verificationToken = await this.$verificationToken();
  }
}

new TasksComponent()
  .$mount('#tasks-view');